export default __webpack_public_path__ + "static/media/BayWare.1702627d.png";